import { CustomerTypeEnum, InvoicingFrequencyEnum, PaymentDueEnum } from "src/types";
import { createIsEnum } from "src/utils";
import { StartPointEnum } from "../approveCustomer";

export type SupplyLimitsSettingsType = {
    id: number;
    acn: number;
    hasCustomizedSupplyLimits: boolean;
};

// type guards
export const isPaymentDueEnum = createIsEnum(PaymentDueEnum);
export const isInvoicingFrequencyEnum = createIsEnum(InvoicingFrequencyEnum);
export const isStartPointEnum = createIsEnum(StartPointEnum);
export const isCustomerTypeEnum = createIsEnum(CustomerTypeEnum);
